<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'job.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <app-reusable-tabs
      #reusableTabs
      [tabConfig]="tabsConfig">
    </app-reusable-tabs>

    <ng-template #openJobTemplate>
      <div class="pt-2">
        <app-open-job-table></app-open-job-table>
      </div>
    </ng-template>

        <ng-template #progressJobTemplate>
      <div class="pt-2">
        <app-job-table
          [filters]="tabs[1].filter!"
          [showExport]="tabs[1].showExport"
          [updatedTranslation]="tabs[1].updatedTranslation">
        </app-job-table>
      </div>
    </ng-template>

    <ng-template #completeJobTemplate>
      <div class="pt-2">
        <app-job-table
          [filters]="tabs[2].filter!"
          [showExport]="tabs[2].showExport"
          [updatedTranslation]="tabs[2].updatedTranslation">
        </app-job-table>
      </div>
    </ng-template>

    <ng-template #cancelledJobTemplate>
      <div class="pt-2">
        <app-job-table
          [filters]="tabs[3].filter!"
          [showExport]="tabs[3].showExport"
          [updatedTranslation]="tabs[3].updatedTranslation">
        </app-job-table>
      </div>
    </ng-template>

    <ng-template #deletedJobTemplate>
      <div class="pt-2">
        <app-job-table
          [filters]="tabs[4].filter!"
          [showExport]="tabs[4].showExport"
          [updatedTranslation]="tabs[4].updatedTranslation">
        </app-job-table>
      </div>
    </ng-template>

    <ng-template #allJobTemplate>
      <div class="pt-2">
        <app-job-table
          [filters]="tabs[5].filter!"
          [showExport]="tabs[5].showExport"
          [updatedTranslation]="tabs[5].updatedTranslation">
        </app-job-table>
      </div>
    </ng-template>
  </div>
</div>
